import { ControlBand, type ControlBandControl } from "core/Controls/ControlBand";
import { type Transform }  from "silver";
import { type RecommendedLang } from "Lang/Pages/Library";

interface ImageBandControl extends ControlBandControl {
	element: HTMLElement;
}

export type ImageBandImageConfiguration = {
	title: string;
	href: string;
	imageURL: string;
};

export class ImageBand {

	private controlBand: ControlBand<ImageBandControl, ImageBandImageConfiguration>;

	public constructor(
		title: string,
		transform: Transform
	) {
		this.controlBand = new ControlBand<ImageBandControl, ImageBandImageConfiguration>(
			{
				getControls: (...source): ImageBandControl[] => {
					return source.map((s) => this.getControl(s));
				}
			},
			transform,
			"-imageBand",
			4,
			300
		);
		this.controlBand.setTitle(title);
	}

	private getControl(source: ImageBandImageConfiguration): ImageBandControl {

		const element = document.createElement("a");
		element.href = source.href;
		element.classList.add("imageBand");


		const imageWrapper    = document.createElement("div");
		imageWrapper.classList.add("imageBand_imageWrapper");
		element.appendChild(imageWrapper);

		const image  = document.createElement("img");
		image.classList.add("imageBand_image");
		image.src = source.imageURL;
		image.alt = source.title;
		imageWrapper.appendChild(image);

		const title  = document.createElement("span");
		title.classList.add("imageBand_title");
		title.innerText = source.title;
		element.appendChild(title);

		return { element };

	}

	public setImageData(data: ImageBandImageConfiguration[]): void {
		this.controlBand.setSourceData(data);
	}


	public handleResize(): void {
		this.controlBand.handleResize();
	}

	public setLang(lang: RecommendedLang): void {
		this.controlBand.setNextButtonLabel(lang.ALT_NEXT_BATCH());
	}

	public get element(): HTMLElement {
		return this.controlBand.element;
	}
}
